import { client } from './client/client.gen'

export type ApiClientOptions = {
  /** '' means same-origin (Firebase Hosting rewrite in prod, Vite proxy in dev) */
  baseUrl: string
  /** Returns a bearer token, or null when unauthenticated */
  getToken: () => Promise<string | null>
}

export function configureApiClient({ baseUrl, getToken }: ApiClientOptions) {
  client.setConfig({
    baseUrl,
    kyOptions: {
      hooks: {
        beforeRequest: [
          async (request: Request) => {
            // getToken() failing must not abort the request outright — an
            // unauthenticated call site (e.g. the staff-invitation preview,
            // which runs before any session exists) would otherwise render
            // a valid response as a network failure. Falling back to no
            // Authorization header lets the request proceed; an endpoint
            // that actually requires auth still rejects it normally (401).
            let token: string | null = null
            try {
              token = await getToken()
            } catch {
              token = null
            }
            if (token) {
              request.headers.set('Authorization', `Bearer ${token}`)
            }
            if (typeof window !== 'undefined' && window.localStorage) {
              const match = request.url.match(/\/weddings\/([^/]+)/)
              if (match && match[1]) {
                const weddingId = match[1]
                const dt = localStorage.getItem(`wedding_display_token_${weddingId}`)
                if (dt) {
                  request.headers.set('X-Display-Token', dt)
                }
              }
            }
          },
        ],
      },
    },
  })
}

export * from './client'
